<script setup>
import {defineModel, defineProps, defineEmits} from 'vue'
import BaseRadioBullet from '@shared-components/base/BaseRadioBullet.vue'

const modelValue = defineModel({required: true})
const emit = defineEmits(['change'])

// Props & emits
const props = defineProps({
  id: {
    type: String,
    required: true,
  },
  value: {
    type: String,
    required: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  name: {
    type: String,
    required: true,
  },
  label: {
    type: String,
    required: true,
  },
})

const onChange = value => {
  emit('change', value)
}
</script>
<template>
  <div class="form-check">
    <base-radio-bullet
      v-model="modelValue"
      :name="props.name"
      :id="props.id"
      :value="props.value"
      :disabled="props.disabled"
      @change="onChange"
    />
    <label class="form-check-label" :for="props.id">{{ props.label }}</label>
  </div>
</template>

<style lang="scss" scoped>
.form-check {
  display: flex;
  align-items: center;
}

.form-check-input[type='radio'] {
  appearance: none;
  -webkit-appearance: none;
  background-color: transparent;
  border: 1px solid #d1d5db;
  border-radius: 50%;
  width: 18px;
  height: 18px;
  position: relative;
  cursor: pointer;
  transition: all 0.15s ease-in-out;
  margin-right: 8px;
  margin-top: 0;

  &:checked {
    border: 2px solid $primary;
  }
}

.form-check-input[type='radio']::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 9px;
  height: 9px;
  background-color: $primary;
  border-radius: 50%;
  transform: translate(-50%, -50%) scale(0);
  transition: transform 0.2s ease-in-out;
}

.form-check-input[type='radio']:checked::before {
  transform: translate(-50%, -50%) scale(1);
}

.form-check-input[type='radio']:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.form-check-label {
  cursor: pointer;
  font-weight: 500;
  margin-bottom: 0 !important;
}

.was-validated .form-check-input:valid:checked,
.form-check-input.is-valid:checked {
  background-color: transparent;
}
</style>
